import { useEffect, useState } from 'react';
import { BrowserRouter, useHistory, useLocation } from 'react-router-dom';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import qs from 'qs';
import { CardsFilter } from '../cards';
import { useEventFilter, useMonths } from './api';

const EventFilterKernel = ({ title, all = false }) => {
  const location = useLocation();
  const history = useHistory();

  const getMonthValueFromUrl = () => {
    const { search } = location;
    const searchParams = new URLSearchParams(search);
    const monthFromSearch = searchParams.get('month');
    return monthFromSearch || '0';
  };

  const [selectedMonth, setSelectedMonth] = useState(getMonthValueFromUrl());
  const [fetchedEvents, status, setMonth] = useEventFilter();
  const [months] = useMonths();

  const [page, setPage] = useState(1);
  const perPage = 12;
  const start = all ? (page - 1) * perPage : 0;
  const end = all ? start + perPage : fetchedEvents.length;

  let pagination = null;
  if (all && fetchedEvents.length > perPage) {
    pagination = {
      page,
      perPage,
      total: fetchedEvents.length,
      onChange: (selected) => setPage(selected),
    };
  }

  useEffect(() => {
    const month = getMonthValueFromUrl();
    setSelectedMonth(month);
    setMonth(month);
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleSelectChange = (month) => {
    setSelectedMonth(month);
    const searchParamsString = qs.stringify({ month });
    history.push({
      pathname: location.pathname,
      search: searchParamsString,
    });
  };

  const filters = [
    {
      title: 'View by month',
      options: [
        { key: 0, value: 0, label: 'Viewing all', disabled: false },
        ...months.map((month, key) => ({
          key: month.month,
          value: key + 1,
          label: `${month.month} (${pluralize(
            'event',
            month.eventCount,
            true
          )})`,
          disabled: month.eventCount === 0,
        })),
      ],
      onChange: ({ value }) => handleSelectChange(value),
      initialValue: selectedMonth,
    },
  ];

  const moreLink = !all ? (
    <div className="d-flex justify-content-center mt-5">
      <a
        className="btn btn-outline-primary"
        href={`${window.location.pathname.replace(/\/+$/, '')}/all`}
      >
        View all events
      </a>
    </div>
  ) : null;

  return (
    <CardsFilter
      filters={filters}
      cardsFilterTitle={title}
      filterPosition="right"
      cards={isArray(fetchedEvents) ? fetchedEvents.slice(start, end) : []}
      cardAttrs={{
        hidePrice: true,
        buttonClassName: 'btn-outline-primary',
      }}
      fetchStatus={status}
      pagination={pagination}
      moreLink={moreLink}
    />
  );
};

const EventFilter = (props) => (
  <BrowserRouter>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <EventFilterKernel {...props} />
  </BrowserRouter>
);

export { EventFilter, EventFilterKernel };

EventFilterKernel.propTypes = {
  title: PropTypes.string,
  all: PropTypes.bool,
};
